import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

type Props = PropsWithClassName & {
    showLegacyTitlebar?: boolean;
};

/**
 * This component is intended to be used in the Desktop Application where we use a custom title bar.
 * The component ensures that the window can still be dragged around.
 */
export const DesktopTitlebar: FC<Props> = ({ className, showLegacyTitlebar = false }) => {
    if (showLegacyTitlebar) {
        return (
            <div className="fixed h-4 w-full">
                <div className="h-4 w-full [-webkit-app-region:drag]" />
            </div>
        );
    }

    return (
        <div className={cn("h-7 w-full flex-shrink-0", className)}>
            <div className="size-full [-webkit-app-region:drag]" />
        </div>
    );
};
